import React, { useEffect, useState } from "react";
import { Alert, Input, Button } from "reactstrap";
import StepCompleteActionButton from "./StepCompleteActionButton";

const PassportFlow = ({
    preview,
    email,
    rawText,
    onRetake,
    onSubmit
}) => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const [fields, setFields] = useState({
        passportNumber: "",
        passportExpiration: ""
    });

    const updateField = (k, v) =>
        setFields(prev => ({ ...prev, [k]: v }));

    // -------------------------------
    // PARSE RAW PASSPORT TEXT
    // -------------------------------
    const parsePassport = (raw) => {
        const lines = raw.split("\n").map(l => l.trim()).filter(Boolean);
        let pNumber = "";
        let exp = "";

        for (let i = 0; i < lines.length; i++) {
            if (lines[i].toUpperCase() === "USA") {
                const next = lines[i + 1] || "";
                const m = next.match(/^\d{6,12}$/);
                if (m) pNumber = m[0];
            }
        }

        if (!pNumber) {
            const last = lines[lines.length - 1];
            const m = last.match(/(\d+)(?=USA)/);
            if (m) pNumber = m[1].slice(0, 9);
        }

        if (!pNumber) {
            const nineDigit = raw.match(/\b\d{9}\b/);
            if (nineDigit) pNumber = nineDigit[0];
        }

        const expIndex = lines.findIndex(l => l.toLowerCase().includes("exp"));
        if (expIndex !== -1) {
            const candidates = [
                lines[expIndex + 1],
                lines[expIndex + 2],
                lines[expIndex + 3]
            ].filter(Boolean);

            const dateRegex = /\b(\d{1,2} [A-Za-z]{3} \d{4})\b/;
            for (const c of candidates) {
                const m = c.match(dateRegex);
                if (m) exp = m[1];
            }
        }

        setFields({
            passportNumber: pNumber,
            passportExpiration: exp
        });
    };

    useEffect(() => {
        if (rawText) parsePassport(rawText);
    }, [rawText]);

    // -------------------------------
    // FINAL SUBMIT
    // -------------------------------
    const submitFinal = async () => {
        setError("");
        setLoading(true);

        if (!fields.passportNumber) {
            setError("Passport number required");
            setLoading(false);
            return;
        }

        const payload = {
            type: "passport",
            data: {
                email,
                passport_number: fields.passportNumber,
                passport_expiration: fields.passportExpiration
            }
        };

        try {
            const resp = await onSubmit(payload);
            if (!resp || resp.code !== 1) {
                setError(resp?.message || "Save failed");
                setLoading(false);
                return;
            }
        } catch (err) {
            setError("Unexpected error");
            setLoading(false);
        }
    };

    // -------------------------------
    // UI
    // -------------------------------
    return (
        <>
            {error && <Alert color="danger">{error}</Alert>}

            <h1 className="text-dark mb-3 fw-semibold">Verify Passport</h1>

            {preview && (
                <img
                    src={preview}
                    alt="passport"
                    style={{ width: "100%", borderRadius: 8, marginBottom: 20 }}
                />
            )}

            <label>Passport Number</label>
            <Input
                className="mb-3"
                value={fields.passportNumber}
                onChange={(e) => updateField("passportNumber", e.target.value.toUpperCase())}
            />

            <label>Expiration Date</label>
            <Input
                className="mb-3"
                value={fields.passportExpiration}
                onChange={(e) => updateField("passportExpiration", e.target.value)}
                placeholder="MM/DD/YYYY"
            />

            <StepCompleteActionButton
                label={loading ? "SAVING..." : "SUBMIT"}
                onClick={submitFinal}
                disabled={loading}
            />

            <Button className="w-100 mt-2" color="secondary" onClick={onRetake}>
                RETAKE PICTURE
            </Button>
        </>
    );
};

export default PassportFlow;